import { InitialStateType } from './types';

export const initialState: InitialStateType = {
  posTerminal: undefined,
  isPosPayment: false,
};
